// @ts-nocheck

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";
export type ChatParticipantFragment = {
  avatar?: string | null;
  name: string;
  profileId?: string | null;
};

export type ReservationWorkerFragment = {
  avatar?: string | null;
  description?: string | null;
  experience?: string | null;
  id: string;
  name: string;
  phone: string;
};

export type ReservationCustomerFragment = { avatar?: string | null; name: string; phone: string };

export type ChecklistFragment = {
  description?: string | null;
  iconUrl?: string | null;
  position?: number | null;
  title?: string | null;
};

export type BundleChecklistFragment = {
  description: string;
  iconUrl: string;
  position: number;
  title: string;
};

export type BundleSubscriptionOptionFragment = {
  description: string;
  discount: number;
  duration: string;
  title: string;
  isFeatured: boolean;
  id: string;
};

export type AttributeValueFragment = {
  description?: string | null;
  id: string;
  isFeatured: boolean;
  name: string;
  position: number;
  price: number;
  timeConsumption: string;
};

export type BundleQuestionAnswerFragment = {
  description: string;
  id: string;
  isFeatured: boolean;
  name: string;
  position: number;
  price: number;
  timeConsumption: string;
};

export type ServiceVariantFragment = {
  description: string;
  id: string;
  price: number;
  isFeatured: boolean;
  isFree: boolean;
  timeConsumption: string;
  title: string;
};

export type BundleAdditionalVariantFragment = {
  description: string;
  id: string;
  price: number;
  isFeatured: boolean;
  isFree: boolean;
  timeConsumption: string;
  title: string;
};

export type OrderServiceVariantsFragment = {
  currency: string;
  description: string;
  isFree?: boolean | null;
  price: number;
  quantity: number;
  sumPrice: any;
  sumTimeConsumption: string;
  timeConsumption: string;
  title: string;
  variantId: string;
};

export type AttributeFragment = {
  description?: string | null;
  id: string;
  isRequired?: boolean | null;
  name: string;
  position: number;
  type: APITypes.AttributeType;
  options: Array<{
    description?: string | null;
    id: string;
    isFeatured: boolean;
    name: string;
    position: number;
    price: number;
    timeConsumption: string;
  }>;
};

export type BundleQuestionFragment = {
  description?: string | null;
  additionalDescription: string;
  wysiwygDescription: string;
  iconUrl: string;
  id: string;
  isRequired: boolean;
  isFeatured: boolean;
  name: string;
  position: number;
  type: APITypes.AttributeType;
  numericType?: APITypes.NumericType | null;
  answers: Array<{
    description: string;
    id: string;
    isFeatured: boolean;
    name: string;
    position: number;
    price: number;
    timeConsumption: string;
  }>;
};

export type BundleQuestionCategoryFragment = {
  id: string;
  title: string;
  description: string;
  position: number;
  questions: Array<{
    description?: string | null;
    additionalDescription: string;
    wysiwygDescription: string;
    iconUrl: string;
    id: string;
    isRequired: boolean;
    isFeatured: boolean;
    name: string;
    position: number;
    type: APITypes.AttributeType;
    numericType?: APITypes.NumericType | null;
    answers: Array<{
      description: string;
      id: string;
      isFeatured: boolean;
      name: string;
      position: number;
      price: number;
      timeConsumption: string;
    }>;
  }>;
};

export type ServiceFragment = {
  additionalDescription: string;
  description: string;
  icon: string;
  id: string;
  name: string;
  variants: Array<{
    description: string;
    id: string;
    price: number;
    isFeatured: boolean;
    isFree: boolean;
    timeConsumption: string;
    title: string;
  }>;
};

export type BundleAdditionalFragment = {
  additionalDescription: string;
  description: string;
  icon: string;
  id: string;
  name: string;
  variants: Array<{
    description: string;
    id: string;
    price: number;
    isFeatured: boolean;
    isFree: boolean;
    timeConsumption: string;
    title: string;
  }>;
};

export type SwapFields_FulfilledSwap_Fragment = {
  id: string;
  fromReservation: { id: string };
  toReservation: { id: string };
  payment?: {
    id: string;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  } | null;
};

export type SwapFields_NotFulfilledSwap_Fragment = {
  id: string;
  fromReservation: { id: string };
  toReservation?: { id: string } | null;
  payment?: {
    id: string;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  } | null;
};

export type SwapFields_SwapRequiresAction_Fragment = {
  id: string;
  fromReservation: { id: string };
  toReservation?: { id: string } | null;
  payment: {
    id: string;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  };
};

export type SwapFieldsFragment =
  | SwapFields_FulfilledSwap_Fragment
  | SwapFields_NotFulfilledSwap_Fragment
  | SwapFields_SwapRequiresAction_Fragment;

export type BillingAddressFragment = {
  city?: string | null;
  country?: string | null;
  email?: string | null;
  line1?: string | null;
  line2?: string | null;
  name: string;
  postal_code?: string | null;
  state?: string | null;
  taxIdentification?: string | null;
};

export type PaymentFragment = {
  amount: number;
  appliedDiscount: number;
  currency: string;
  id: string;
  paymentMethodId?: string | null;
  paymentUpdateDate?: string | null;
  status: APITypes.PaymentStatus;
  stripePaymentNextStep?:
    | {
        clientSecret: string;
        paymentIntentId: string;
        redirectUrl: string;
        type: APITypes.PaymentActionType;
      }
    | {
        clientSecret: string;
        paymentIntentId: string;
        stripeSdkData: string;
        type: APITypes.PaymentActionType;
      }
    | null;
};

export type OrderProcessingFeeFragment = {
  amount: number;
  currency: string;
  type: APITypes.ProcessingFeeType;
};

export type SubscriptionProcessingFeeFragment = {
  amount: number;
  currency: string;
  promoCode: string;
  promoCodeAlreadyUsed: boolean;
  type: APITypes.ProcessingFeeType;
};

export type ReviewFragment = {
  comment: string;
  customerId: string;
  customerName: string;
  customerProfilePhoto?: string | null;
  id: string;
  rating: number;
  reservationCity: string;
  reservationStartedAt: string;
  title: string;
  postedAt: string;
};

export type ReviewEdgeFragment = {
  cursor: any;
  node: {
    comment: string;
    customerId: string;
    customerName: string;
    customerProfilePhoto?: string | null;
    id: string;
    rating: number;
    reservationCity: string;
    reservationStartedAt: string;
    title: string;
    postedAt: string;
  };
};

export type ReviewConnectionFragment = {
  edges: Array<{
    cursor: any;
    node: {
      comment: string;
      customerId: string;
      customerName: string;
      customerProfilePhoto?: string | null;
      id: string;
      rating: number;
      reservationCity: string;
      reservationStartedAt: string;
      title: string;
      postedAt: string;
    };
  }>;
  pageInfo: {
    endCursor?: any | null;
    hasNextPage?: boolean | null;
    hasPreviousPage?: boolean | null;
    startCursor?: any | null;
  };
};

export type ReviewAggregateResponseFragment = {
  avg?: { rating?: number | null } | null;
  sum?: { rating?: number | null } | null;
};

export type OrderPeriodicityFragment = {
  cycleDuration: string;
  description: string;
  discount: number;
  id: string;
  title: string;
};

export type OrderDiscountFragment = {
  fixedValue: number;
  id: string;
  type: APITypes.OrderDiscountType;
};

export type OrderHouseAreaFragment = {
  houseAreaAttributeId: string;
  houseAreaStepId: string;
  price: any;
  timeConsumption: string;
  discount?: Array<{
    fixedValue: number;
    id: string;
    type: APITypes.OrderDiscountType;
  } | null> | null;
};

export type OrderAttributeFragment = {
  currency: string;
  price: number;
  quantity?: number | null;
  timeConsumption?: string | null;
  attribute: {
    description?: string | null;
    id: string;
    isRequired?: boolean | null;
    name: string;
    position: number;
    type: APITypes.AttributeType;
    options: Array<{
      description?: string | null;
      id: string;
      isFeatured: boolean;
      name: string;
      position: number;
      price: number;
      timeConsumption: string;
    }>;
  };
  values: Array<{
    description?: string | null;
    id: string;
    isFeatured: boolean;
    name: string;
    position: number;
    price: number;
    timeConsumption: string;
  } | null>;
};

export type OrderServiceFragment = {
  currency: string;
  price: number;
  timeConsumption: string;
  service: {
    additionalDescription: string;
    description: string;
    icon: string;
    id: string;
    name: string;
    variants: Array<{
      description: string;
      id: string;
      price: number;
      isFeatured: boolean;
      isFree: boolean;
      timeConsumption: string;
      title: string;
    }>;
  };
  variants: Array<{
    currency: string;
    description: string;
    isFree?: boolean | null;
    price: number;
    quantity: number;
    sumPrice: any;
    sumTimeConsumption: string;
    timeConsumption: string;
    title: string;
    variantId: string;
  }>;
};

export type ReservationListServicesFragment = {
  service: { id: string; name: string };
  variants: Array<{ quantity: number; variantId: string }>;
};

export type AddressFragment = {
  city: string;
  doorCode?: string | null;
  floorArea?: number | null;
  notes?: string | null;
  postalOrZipCode: string;
  streetAddress1: string;
  streetAddress2?: string | null;
  type?: APITypes.ApartmentType | null;
};

export type V2BundleFragment = {
  categoryType: APITypes.CategoryType;
  description: string;
  id: string;
  name: string;
  startingPrice: number;
  position: number;
  isAdditionalTitleAndDescriptionEnabled: boolean;
  additionalTitle: string;
  additionalDescription: string;
  slug: string;
  checkList: Array<{ description: string; iconUrl: string; position: number; title: string }>;
  houseArea?: { id: string; enabled: boolean; steps: Array<{ from: number; to: number }> } | null;
  categories: Array<{
    id: string;
    title: string;
    description: string;
    position: number;
    questions: Array<{
      description?: string | null;
      additionalDescription: string;
      wysiwygDescription: string;
      iconUrl: string;
      id: string;
      isRequired: boolean;
      isFeatured: boolean;
      name: string;
      position: number;
      type: APITypes.AttributeType;
      numericType?: APITypes.NumericType | null;
      answers: Array<{
        description: string;
        id: string;
        isFeatured: boolean;
        name: string;
        position: number;
        price: number;
        timeConsumption: string;
      }>;
    }>;
  }>;
  questions: Array<{
    description?: string | null;
    additionalDescription: string;
    wysiwygDescription: string;
    iconUrl: string;
    id: string;
    isRequired: boolean;
    isFeatured: boolean;
    name: string;
    position: number;
    type: APITypes.AttributeType;
    numericType?: APITypes.NumericType | null;
    answers: Array<{
      description: string;
      id: string;
      isFeatured: boolean;
      name: string;
      position: number;
      price: number;
      timeConsumption: string;
    }>;
  }>;
  services: Array<{
    additionalDescription: string;
    description: string;
    icon: string;
    id: string;
    name: string;
    variants: Array<{
      description: string;
      id: string;
      price: number;
      isFeatured: boolean;
      isFree: boolean;
      timeConsumption: string;
      title: string;
    }>;
  }>;
  subscriptionOptions: Array<{
    description: string;
    discount: number;
    duration: string;
    title: string;
    isFeatured: boolean;
    id: string;
  }>;
};

export type V2BundleListFragment = {
  bannerRedirection: string;
  categoryType: APITypes.CategoryType;
  currency: string;
  description: string;
  desktopBanner: string;
  id: string;
  isBanner: boolean;
  isFeatured: boolean;
  name: string;
  mobileBanner: string;
  position: number;
  slug: string;
  startingPrice: number;
  checkList: Array<{ description: string; iconUrl: string; position: number; title: string }>;
};

export type CategoryFragment = {
  bannerRedirection: string;
  description?: string | null;
  desktopUrl: string;
  extraDesktopUrl: string;
  extraMobileUrl: string;
  desktopBannerUrl: string;
  id: string;
  isBanner: boolean;
  isFeatured: boolean;
  localizationId: string;
  mobileUrl: string;
  mobileBannerUrl: string;
  name: string;
  position: number;
  slug: string;
  startingPrice: number;
};

export type BundleListFragment = {
  desktopBanner: string;
  id: string;
  mobileBanner: string;
  name: string;
  slug: string;
  startingPriceWithCurrency?: string | null;
  isBanner: boolean;
  bannerRedirection: string;
  position: number;
  checkList: Array<{
    description?: string | null;
    iconUrl?: string | null;
    position?: number | null;
    title?: string | null;
  }>;
};

export type ReservationVmFragment = {
  adminNote: string;
  currency: string;
  customerNote: string;
  id: string;
  laborPrice?: number;
  locationId: string;
  price?: number;
  shouldUseDiscount?: boolean;
  startDate: string;
  status: APITypes.ReservationStatus;
  timeConsumption: string;
  address: {
    city: string;
    doorCode?: string | null;
    floorArea?: number | null;
    notes?: string | null;
    postalOrZipCode: string;
    streetAddress1: string;
    streetAddress2?: string | null;
    type?: APITypes.ApartmentType | null;
  };
  attributes: Array<{
    currency: string;
    price: number;
    quantity?: number | null;
    timeConsumption?: string | null;
    attribute: {
      description?: string | null;
      id: string;
      isRequired?: boolean | null;
      name: string;
      position: number;
      type: APITypes.AttributeType;
      options: Array<{
        description?: string | null;
        id: string;
        isFeatured: boolean;
        name: string;
        position: number;
        price: number;
        timeConsumption: string;
      }>;
    };
    values: Array<{
      description?: string | null;
      id: string;
      isFeatured: boolean;
      name: string;
      position: number;
      price: number;
      timeConsumption: string;
    } | null>;
  } | null>;
  bundle: { id: string; categoryType?: APITypes.CategoryType | null; name: string; slug: string };
  completionPhotos?: Array<{ file: { url: string } }> | null;
  customer?: { avatar?: string | null; name: string; phone: string };
  discounts?: Array<{ fixedValue: number; id: string; type: APITypes.OrderDiscountType }> | null;
  payment?: {
    amount: number;
    appliedDiscount: number;
    currency: string;
    id: string;
    paymentMethodId?: string | null;
    paymentUpdateDate?: string | null;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  } | null;
  periodicity: { title: string };
  review?: { id: string } | null;
  services: Array<{
    currency: string;
    price: number;
    timeConsumption: string;
    service: {
      additionalDescription: string;
      description: string;
      icon: string;
      id: string;
      name: string;
      variants: Array<{
        description: string;
        id: string;
        price: number;
        isFeatured: boolean;
        isFree: boolean;
        timeConsumption: string;
        title: string;
      }>;
    };
    variants: Array<{
      currency: string;
      description: string;
      isFree?: boolean | null;
      price: number;
      quantity: number;
      sumPrice: any;
      sumTimeConsumption: string;
      timeConsumption: string;
      title: string;
      variantId: string;
    }>;
  } | null>;
  subscription?: { id: string; startDate: string; periodicity: { cycleDuration: string } } | null;
  workers: Array<{
    avatar?: string | null;
    description?: string | null;
    experience?: string | null;
    id: string;
    name: string;
    phone: string;
  } | null>;
};

export type ReservationListFragment = {
  adminNote: string;
  currency: string;
  customerNote: string;
  endDate: string;
  id: string;
  laborPrice?: number;
  price?: number;
  startDate: string;
  status: APITypes.ReservationStatus;
  timeConsumption: string;
  address: {
    city: string;
    doorCode?: string | null;
    floorArea?: number | null;
    notes?: string | null;
    postalOrZipCode: string;
    streetAddress1: string;
    streetAddress2?: string | null;
    type?: APITypes.ApartmentType | null;
  };
  bundle: { name: string; checkList: Array<{ title?: string | null }> };
  customer?: { avatar?: string | null; name: string; phone: string };
  payment?: {
    amount: number;
    appliedDiscount: number;
    currency: string;
    id: string;
    paymentMethodId?: string | null;
    paymentUpdateDate?: string | null;
    status: APITypes.PaymentStatus;
    stripePaymentNextStep?:
      | {
          clientSecret: string;
          paymentIntentId: string;
          redirectUrl: string;
          type: APITypes.PaymentActionType;
        }
      | {
          clientSecret: string;
          paymentIntentId: string;
          stripeSdkData: string;
          type: APITypes.PaymentActionType;
        }
      | null;
  } | null;
  periodicity: { title: string };
  review?: { id: string } | null;
  services: Array<{
    service: { id: string; name: string };
    variants: Array<{ quantity: number; variantId: string }>;
  } | null>;
  subscription?: { id: string; startDate: string; periodicity: { cycleDuration: string } } | null;
  workers: Array<{
    avatar?: string | null;
    description?: string | null;
    experience?: string | null;
    id: string;
    name: string;
    phone: string;
  } | null>;
};

export type ChatMessageFragment = {
  attachments?: Array<string> | null;
  content: string;
  createdAt: string;
  id: string;
  state: APITypes.MessageState;
  author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
};

export type ChatChannelFragment = {
  hasUnreadMessages: boolean;
  id: string;
  state: APITypes.ChannelState;
  messages?: Array<{
    attachments?: Array<string> | null;
    content: string;
    createdAt: string;
    id: string;
    state: APITypes.MessageState;
    author?: { avatar?: string | null; name: string; profileId?: string | null } | null;
  }> | null;
  order: { id: string };
  participants: Array<{ avatar?: string | null; name: string; profileId?: string | null }>;
};

export const SwapFieldsFragmentDoc = gql`
    fragment SwapFields on Swap {
  id
  fromReservation {
    id
  }
  toReservation {
    id
  }
  payment {
    id
    status
    stripePaymentNextStep {
      ... on PaymentRedirectStep {
        clientSecret
        paymentIntentId
        redirectUrl
        type
      }
      ... on PaymentStripeSdkStep {
        clientSecret
        paymentIntentId
        stripeSdkData
        type
      }
    }
  }
}
    `;
export const BillingAddressFragmentDoc = gql`
    fragment BillingAddress on BillingAddress {
  city
  country
  email
  line1
  line2
  name
  postal_code
  state
  taxIdentification
}
    `;
export const OrderProcessingFeeFragmentDoc = gql`
    fragment OrderProcessingFee on OrderProcessingFee {
  amount
  currency
  type
}
    `;
export const SubscriptionProcessingFeeFragmentDoc = gql`
    fragment SubscriptionProcessingFee on SubscriptionProcessingFee {
  amount
  currency
  promoCode
  promoCodeAlreadyUsed
  type
}
    `;
export const ReviewFragmentDoc = gql`
    fragment Review on Review {
  comment
  customerId
  customerName
  customerProfilePhoto
  id
  rating
  reservationCity
  reservationStartedAt
  title
  postedAt
}
    `;
export const ReviewEdgeFragmentDoc = gql`
    fragment ReviewEdge on ReviewEdge {
  cursor
  node {
    ...Review
  }
}
    ${ReviewFragmentDoc}`;
export const ReviewConnectionFragmentDoc = gql`
    fragment ReviewConnection on ReviewConnection {
  edges {
    ...ReviewEdge
  }
  pageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
}
    ${ReviewEdgeFragmentDoc}`;
export const ReviewAggregateResponseFragmentDoc = gql`
    fragment ReviewAggregateResponse on ReviewAggregateResponse {
  avg {
    rating
  }
  sum {
    rating
  }
}
    `;
export const OrderPeriodicityFragmentDoc = gql`
    fragment OrderPeriodicity on OrderPeriodicity {
  cycleDuration
  description
  discount
  id
  title
}
    `;
export const OrderDiscountFragmentDoc = gql`
    fragment OrderDiscount on OrderDiscount {
  fixedValue
  id
  type
}
    `;
export const OrderHouseAreaFragmentDoc = gql`
    fragment OrderHouseArea on OrderHouseArea {
  discount {
    ...OrderDiscount
  }
  houseAreaAttributeId
  houseAreaStepId
  price
  timeConsumption
}
    ${OrderDiscountFragmentDoc}`;
export const BundleChecklistFragmentDoc = gql`
    fragment BundleChecklist on v2BundleCheckList {
  description
  iconUrl
  position
  title
}
    `;
export const BundleQuestionAnswerFragmentDoc = gql`
    fragment BundleQuestionAnswer on v2BundleQuestionAnswer {
  description
  id
  isFeatured
  name
  position
  price
  timeConsumption
}
    `;
export const BundleQuestionFragmentDoc = gql`
    fragment BundleQuestion on v2BundleQuestion {
  description
  additionalDescription
  wysiwygDescription
  iconUrl
  id
  isRequired
  isFeatured
  name
  answers {
    ...BundleQuestionAnswer
  }
  position
  type
  numericType
}
    ${BundleQuestionAnswerFragmentDoc}`;
export const BundleQuestionCategoryFragmentDoc = gql`
    fragment BundleQuestionCategory on v2BundleQuestionCategory {
  id
  title
  description
  position
  questions {
    ...BundleQuestion
  }
}
    ${BundleQuestionFragmentDoc}`;
export const BundleAdditionalVariantFragmentDoc = gql`
    fragment BundleAdditionalVariant on v2BundleAdditionalVariant {
  description
  id
  price
  isFeatured
  isFree(bundleId: $bundleId)
  timeConsumption
  title
}
    `;
export const BundleAdditionalFragmentDoc = gql`
    fragment BundleAdditional on v2BundleAdditional {
  additionalDescription
  description
  icon
  id
  name
  variants {
    ...BundleAdditionalVariant
  }
}
    ${BundleAdditionalVariantFragmentDoc}`;
export const BundleSubscriptionOptionFragmentDoc = gql`
    fragment BundleSubscriptionOption on v2BundleSubscriptionOption {
  description
  discount
  duration
  title
  isFeatured
  id
}
    `;
export const V2BundleFragmentDoc = gql`
    fragment V2Bundle on v2Bundle {
  categoryType
  checkList {
    ...BundleChecklist
  }
  description
  id
  name
  houseArea {
    id
    enabled
    steps {
      from
      to
    }
  }
  startingPrice
  position
  isAdditionalTitleAndDescriptionEnabled
  additionalTitle
  additionalDescription
  categories {
    ...BundleQuestionCategory
  }
  questions {
    ...BundleQuestion
  }
  services {
    ...BundleAdditional
  }
  slug
  subscriptionOptions {
    ...BundleSubscriptionOption
  }
}
    ${BundleChecklistFragmentDoc}
${BundleQuestionCategoryFragmentDoc}
${BundleQuestionFragmentDoc}
${BundleAdditionalFragmentDoc}
${BundleSubscriptionOptionFragmentDoc}`;
export const V2BundleListFragmentDoc = gql`
    fragment V2BundleList on v2Bundle {
  bannerRedirection
  categoryType
  checkList {
    ...BundleChecklist
  }
  currency
  description
  desktopBanner
  id
  isBanner
  isFeatured
  name
  mobileBanner
  position
  slug
  startingPrice
}
    ${BundleChecklistFragmentDoc}`;
export const CategoryFragmentDoc = gql`
    fragment Category on CategoryCustomerModel {
  bannerRedirection
  description
  desktopUrl
  extraDesktopUrl
  extraMobileUrl
  desktopBannerUrl
  id
  isBanner
  isFeatured
  localizationId
  mobileUrl
  mobileBannerUrl
  name
  position
  slug
  startingPrice
}
    `;
export const ChecklistFragmentDoc = gql`
    fragment Checklist on BundleCheckList {
  description
  iconUrl
  position
  title
}
    `;
export const BundleListFragmentDoc = gql`
    fragment BundleList on Bundle {
  checkList {
    ...Checklist
  }
  desktopBanner
  id
  mobileBanner
  name
  slug
  startingPriceWithCurrency
  isBanner
  bannerRedirection
  position
}
    ${ChecklistFragmentDoc}`;
export const AddressFragmentDoc = gql`
    fragment Address on Address {
  city
  doorCode
  floorArea
  notes
  postalOrZipCode
  streetAddress1
  streetAddress2
  type
}
    `;
export const AttributeValueFragmentDoc = gql`
    fragment AttributeValue on AttributeValue {
  description
  id
  isFeatured
  name
  position
  price
  timeConsumption
}
    `;
export const AttributeFragmentDoc = gql`
    fragment Attribute on Attribute {
  description
  id
  isRequired
  name
  options {
    ...AttributeValue
  }
  position
  type
}
    ${AttributeValueFragmentDoc}`;
export const OrderAttributeFragmentDoc = gql`
    fragment OrderAttribute on OrderAttribute {
  attribute {
    ...Attribute
  }
  currency
  price
  quantity
  timeConsumption
  values {
    ...AttributeValue
  }
}
    ${AttributeFragmentDoc}
${AttributeValueFragmentDoc}`;
export const ReservationCustomerFragmentDoc = gql`
    fragment ReservationCustomer on ReservationCustomer {
  avatar
  name
  phone
}
    `;
export const PaymentFragmentDoc = gql`
    fragment Payment on Payment {
  amount
  appliedDiscount
  currency
  id
  paymentMethodId
  paymentUpdateDate
  status
  stripePaymentNextStep {
    ... on PaymentRedirectStep {
      clientSecret
      paymentIntentId
      redirectUrl
      type
    }
    ... on PaymentStripeSdkStep {
      clientSecret
      paymentIntentId
      stripeSdkData
      type
    }
  }
}
    `;
export const ServiceVariantFragmentDoc = gql`
    fragment ServiceVariant on ServiceVariant {
  description
  id
  price
  isFeatured
  isFree(bundleId: $bundleId)
  timeConsumption
  title
}
    `;
export const ServiceFragmentDoc = gql`
    fragment Service on Service {
  additionalDescription
  description
  icon
  id
  name
  variants {
    ...ServiceVariant
  }
}
    ${ServiceVariantFragmentDoc}`;
export const OrderServiceVariantsFragmentDoc = gql`
    fragment OrderServiceVariants on OrderServiceVariants {
  currency
  description
  isFree
  price
  quantity
  sumPrice
  sumTimeConsumption
  timeConsumption
  title
  variantId
}
    `;
export const OrderServiceFragmentDoc = gql`
    fragment OrderService on OrderService {
  currency
  price
  service {
    ...Service
  }
  timeConsumption
  variants {
    ...OrderServiceVariants
  }
}
    ${ServiceFragmentDoc}
${OrderServiceVariantsFragmentDoc}`;
export const ReservationWorkerFragmentDoc = gql`
    fragment ReservationWorker on ReservationWorker {
  avatar
  description
  experience
  id
  name
  phone
}
    `;
export const ReservationVmFragmentDoc = gql`
    fragment ReservationVM on ReservationVM {
  address {
    ...Address
  }
  adminNote
  attributes {
    ...OrderAttribute
  }
  bundle {
    id
    categoryType
    name
    slug
  }
  completionPhotos @include(if: $isCustomerApp) {
    file {
      url
    }
  }
  currency
  customer @skip(if: $isCustomerApp) {
    ...ReservationCustomer
  }
  customerNote
  discounts @include(if: $isCustomerApp) {
    ...OrderDiscount
  }
  id
  laborPrice @skip(if: $isCustomerApp)
  locationId
  payment @include(if: $isCustomerApp) {
    ...Payment
  }
  periodicity {
    title
  }
  price @include(if: $isCustomerApp)
  review @skip(if: $isCustomerApp) {
    id
  }
  services {
    ...OrderService
  }
  shouldUseDiscount @include(if: $isCustomerApp)
  startDate
  status
  subscription {
    id
    startDate
    periodicity {
      cycleDuration
    }
  }
  timeConsumption
  workers {
    ...ReservationWorker
  }
}
    ${AddressFragmentDoc}
${OrderAttributeFragmentDoc}
${ReservationCustomerFragmentDoc}
${OrderDiscountFragmentDoc}
${PaymentFragmentDoc}
${OrderServiceFragmentDoc}
${ReservationWorkerFragmentDoc}`;
export const ReservationListServicesFragmentDoc = gql`
    fragment ReservationListServices on OrderService {
  service {
    id
    name
  }
  variants {
    quantity
    variantId
  }
}
    `;
export const ReservationListFragmentDoc = gql`
    fragment ReservationList on ReservationVM {
  address {
    ...Address
  }
  adminNote
  bundle {
    name
    checkList {
      title
    }
  }
  currency
  customer @skip(if: $isCustomerApp) {
    ...ReservationCustomer
  }
  customerNote
  endDate
  id
  laborPrice @skip(if: $isCustomerApp)
  payment @include(if: $isCustomerApp) {
    ...Payment
  }
  periodicity {
    title
  }
  price @include(if: $isCustomerApp)
  review @include(if: $isCustomerApp) {
    id
  }
  services {
    ...ReservationListServices
  }
  startDate
  status
  subscription {
    id
    startDate
    periodicity {
      cycleDuration
    }
  }
  timeConsumption
  workers {
    ...ReservationWorker
  }
}
    ${AddressFragmentDoc}
${ReservationCustomerFragmentDoc}
${PaymentFragmentDoc}
${ReservationListServicesFragmentDoc}
${ReservationWorkerFragmentDoc}`;
export const ChatParticipantFragmentDoc = gql`
    fragment ChatParticipant on ChatParticipant {
  avatar
  name
  profileId
}
    `;
export const ChatMessageFragmentDoc = gql`
    fragment ChatMessage on ChatMessage {
  attachments
  author {
    ...ChatParticipant
  }
  content
  createdAt
  id
  state
}
    ${ChatParticipantFragmentDoc}`;
export const ChatChannelFragmentDoc = gql`
    fragment ChatChannel on ChatChannel {
  hasUnreadMessages
  id
  messages {
    ...ChatMessage
  }
  order {
    id
  }
  participants {
    avatar
    name
    profileId
  }
  state
}
    ${ChatMessageFragmentDoc}`;
